import { Injectable } from "@angular/core";
import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

@Injectable()
export class CustomValidators {
    public static OptionListValidator(validOptions: any[]): ValidatorFn {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            if (validOptions.find(opt => opt == control.value) == null) {
                return { 'invalidOption': true };
            }
            return null;
        }
    }

    public static emptyFormGroupValidator(): ValidatorFn {
        return (formGroup: AbstractControl): { [key: string]: any } | null => {
            if (!(formGroup instanceof FormGroup)) {
                return null
            }

            const controlCount = Object.keys((<FormGroup>formGroup).controls).length;
            if (controlCount > 0) {
                return null;
            }
            else {
                return { 'noEntries': true };
            }
        }
    }

    public static groupCheckboxValidator(minChecked: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (control instanceof FormArray) {
                const checkedCount = control.controls.filter((c) => c.value.checked === true).length;
                if (checkedCount >= minChecked) {
                    return null;
                }
            }
            return { groupCheckboxInvalid: true };
        };
    }

    // deprecated, use CommonValidators.isEmptyHTMLString() instead
    static emptyHTMLString(): ValidatorFn {
        return (c: AbstractControl): { [key: string]: any } | null => {

            if (!c.value) {
                return { 'emptyHtmlString': true };
            } else {
                var textContent = c.value.replace(/<[^>]*>/g, '');
                textContent = textContent.replace(/&nbsp;|&ensp;|&emsp;|&thinsp;|&zwnj;|&zwj;|&lrm;|&rlm;|\t|\n|\r/gi, '');
                if (!/\S/.test(textContent)) {
                    return { 'emptyHtmlString': true };
                }
            }
            return null;
        };
    }

    /**
     * Rejects a control whose value is still the one it started with, for dialogs whose whole purpose is
     * to change that value.
     *
     * @param originalValue The value the control was opened with.
     * @returns A validator that reports `unchanged` while the control still holds the original value.
     */
    static mustDifferFrom(originalValue: unknown): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return control.value === originalValue ? { unchanged: true } : null;
        };
    }

    static uniqueArrayValidator(array: any[]): ValidatorFn {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
           if (array.find(opt => opt == control.value) != null) {
                return { 'nonUnique': true };
            }
            return null;
        }
    }
}